import { getHomePageInfos } from "./apiClient";
import AppConstants from "./appConstants";
import { markSupportChatUnread } from "./supportChatUnread";

export const MFG_NOTIFICATION_LIST_REFRESH = "mfg:notification-list-refresh";

/**
 * Mirrors Flutter EWalletController.updateEWalletsAmount → InformationController badge refresh.
 */
export async function syncNotificationBadgeFromServer() {
  if (typeof window === "undefined") return null;
  try {
    const response = await getHomePageInfos({ forceRefresh: true });
    const data = response?.decryptedData || response?.data || {};
    if (Number(data?.CODE) !== AppConstants.responseOk || !data?.NOTIFICATIONS) return null;

    const count = Math.max(0, Number(data.NOTIFICATIONS.NOTIFICATIONS) || 0);
    const chatCount = Math.max(0, Number(data.NOTIFICATIONS.CHAT_NOTIFICATIONS) || 0);

    window.dispatchEvent(
      new CustomEvent("mfg:notification-badge", {
        detail: { count },
      })
    );

    if (chatCount > 0) {
      markSupportChatUnread();
    }

    return { count, chatCount };
  } catch (_) {
    return null;
  }
}

export function dispatchNotificationListRefresh() {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent(MFG_NOTIFICATION_LIST_REFRESH));
  } catch (_) {}
}
